import { useEffect, useRef, useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function ScrollStrip({ children, testid, gapClass = "gap-4", className = "" }) {
    const stripRef = useRef(null);
    const [canLeft, setCanLeft] = useState(false);
    const [canRight, setCanRight] = useState(false);

    const check = () => {
        const el = stripRef.current;
        if (!el) return;
        setCanLeft(el.scrollLeft > 8);
        setCanRight(el.scrollWidth - el.clientWidth - el.scrollLeft > 8);
    };

    useEffect(() => {
        check();
        const timer = setTimeout(check, 500);
        window.addEventListener("resize", check);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("resize", check);
        };
    }, [children]);

    const go = (dir) => {
        stripRef.current?.scrollBy({ left: dir * stripRef.current.clientWidth * 0.7, behavior: "smooth" });
    };

    return (
        <div className={`relative ${className}`}>
            <div
                ref={stripRef}
                onScroll={check}
                className={`flex ${gapClass} overflow-x-auto pb-4 snap-x snap-mandatory`}
                data-lenis-prevent
                data-testid={testid}
            >
                {children}
            </div>
            {canLeft && (
                <button
                    type="button"
                    onClick={() => go(-1)}
                    data-testid={`${testid}-scroll-left`}
                    aria-label="Geser ke kiri"
                    className="absolute -left-2 md:-left-5 top-1/2 -translate-y-1/2 z-10 flex items-center bg-white border border-racing-line text-neutral-900 px-2 py-3 shadow-lg hover:border-racing-red hover:text-racing-red transition-colors"
                >
                    <CaretLeft size={22} weight="bold" />
                </button>
            )}
            {canRight && (
                <button
                    type="button"
                    onClick={() => go(1)}
                    data-testid={`${testid}-scroll-right`}
                    aria-label="Geser ke kanan untuk melihat lainnya"
                    className="absolute -right-2 md:-right-5 top-1/2 -translate-y-1/2 z-10 flex items-center gap-1 bg-racing-red text-white pl-3 pr-2 py-3 shadow-lg shadow-racing-red/30 animate-pulse"
                >
                    <span className="hidden md:block text-[9px] uppercase tracking-[0.2em]">Geser</span>
                    <CaretRight size={22} weight="bold" />
                </button>
            )}
        </div>
    );
}
